/**
 * Any Dealer-specific javascript can be added here.
 *
 * The OEM theme's JS is all bundled by mix, but if you need to include a
 * import a specific file, '@oem-theme' is an alias to the OEM theme's
 * 'assets/js' folder, and can be referenced like so:
 * import { convertStrToMilitaryTime } from '@oem-theme/utilities.js';
 *
 * For convenience, '@dealer' is an alias to this theme's 'assets/js' folder.
 */

import $ from 'jquery';
import { __ } from '@wordpress/i18n';

document.addEventListener('DOMContentLoaded', function () {
  const $inventoryPage = $('.page-template-inventory, .home-featured-inventory');

  function applyFuelFeature() {
    $('.vehicle-card').each(function () {
      const $card = $(this);
      const $fuelFeature = $card.find('.vehicle-feature-at-image');
      if ($fuelFeature.length != 0) {
        const $imageContainer = $card.find('.featured-image');
        $imageContainer.append($fuelFeature.clone(true, true));
        $fuelFeature.remove();
      }
    });
  }

  function vehicleUpdateSoldAsIs() {
    $('.vehicle-card').each(function () {
      const $card = $(this);
      const $soldAsIsTag = $card.find('.vehicle-card-label-sold-as-is');
      if ($soldAsIsTag.length != 0) {
        $soldAsIsTag.text(__('As Is Vehicle', 'ford-oem-theme'));
      }
    });
  }

  if ($inventoryPage.length != 0) {
    applyFuelFeature();
    vehicleUpdateSoldAsIs();

    $(document).on('post_render_inventory_search_results', function () {
      applyFuelFeature();
      vehicleUpdateSoldAsIs();
    });
  }

  const $vdpPage = $('.vdp-page');

  if ($vdpPage.length != 0) {

    // Blue Advantange (repurpose Leasing Info meta)

    $vdpPage.find('.vdp-metadata-lease').find('.vdp-metadata-lease__title').text('Ford Blue Advantage');


    // Sold As Is Handling
    const $statusTitle = $vdpPage.find('.details-container .vdp-page__status-title .main-title');

    if ($statusTitle.length != 0) {
      $statusTitle.each(function () {
        const $status = $(this);
        const statusText = $status.text();
        if (statusText.includes('Sold As Is')) {
          const newStatusText = statusText.replaceAll('Sold', '');
          $status.text(newStatusText);
        }
      });
    }

  }
});
